import React, { useState } from "react";
import { Box } from "@mui/material";
import useOutsideClick from "hooks/useOutsideClick";
import {
  StyledDropDownContainer,
  StyledDropDownText,
} from "features/metadesk/settings/IntegrationPage/components/integrationComponent.styles";

export default function TextDropdown({
  text = "",
  options = [],
  style = {},
  isShowDropdown = true,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOutsideClick(() => setIsOpen(false));

  return (
    <Box ref={ref} position="relative">
      <Box
        onClick={() => setIsOpen(true)}
        style={{ cursor: isShowDropdown ? "pointer" : "default", ...style }}
      >
        {text && text}
      </Box>
      {isOpen && isShowDropdown && (
        <StyledDropDownContainer style={{ position: "absolute", zIndex: 999 }}>
          <Box fontSize={12} color="#555">
            {options.map((item, index) => (
              <StyledDropDownText
                key={index}
                onClick={item.action}
                style={{ width: "100%" }}
              >
                {item.label}
              </StyledDropDownText>
            ))}
          </Box>
        </StyledDropDownContainer>
      )}
    </Box>
  );
}
